import { createBrowserRouter, Navigate } from "react-router";
import { Icon } from "./components/Icons";
import { PanelLayout } from "./components/PanelLayout";
import { RequireRole } from "./lib/auth";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminFiscal } from "./pages/admin/AdminFiscal";
import { AdminLogs } from "./pages/admin/AdminLogs";
import { AdminPayouts } from "./pages/admin/AdminPayouts";
import { AdminSettings } from "./pages/admin/AdminSettings";
import { AdminStudent } from "./pages/admin/AdminStudent";
import { AdminStudents } from "./pages/admin/AdminStudents";
import { AdminTeam } from "./pages/admin/AdminTeam";
import { Login } from "./pages/Login";
import { NotFound } from "./pages/NotFound";
import { EnrollmentPage } from "./pages/public/EnrollmentPage";
import { ReportPage } from "./pages/public/ReportPage";
import { LeadDetail } from "./pages/sales/LeadDetail";
import { Leads } from "./pages/sales/Leads";
import { SellerFinance } from "./pages/sales/SellerFinance";
import { TotpSetup } from "./pages/TotpSetup";
import { TeacherAvailability } from "./pages/teacher/TeacherAvailability";
import { TeacherFinance } from "./pages/teacher/TeacherFinance";
import { TeacherStudent } from "./pages/teacher/TeacherStudent";
import { TeacherStudents } from "./pages/teacher/TeacherStudents";

export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/entrar" replace /> },
  { path: "/entrar", element: <Login /> },
  { path: "/entrar/autenticador", element: <TotpSetup /> },
  // Páginas públicas por link único
  { path: "/m/:token", element: <EnrollmentPage /> },
  // A simulação carrega o VAD e o onnxruntime só quando o aluno abre o link.
  {
    path: "/s/:token",
    lazy: async () => ({
      Component: (await import("./pages/public/SimulationPage")).SimulationPage,
    }),
  },
  { path: "/r/:token", element: <ReportPage /> },
  {
    path: "/vendas",
    element: (
      <RequireRole need="seller">
        <PanelLayout
          area="Vendas"
          items={[
            { to: "/vendas", label: "Leads", icon: Icon.leads, end: true },
            { to: "/vendas/financeiro", label: "Financeiro", icon: Icon.money },
          ]}
        />
      </RequireRole>
    ),
    children: [
      { index: true, element: <Leads /> },
      { path: "leads/:id", element: <LeadDetail /> },
      { path: "financeiro", element: <SellerFinance /> },
    ],
  },
  {
    path: "/professor",
    element: (
      <RequireRole need="teacher">
        <PanelLayout
          area="Professor"
          items={[
            { to: "/professor/alunos", label: "Meus alunos", icon: Icon.students },
            { to: "/professor/disponibilidade", label: "Disponibilidade", icon: Icon.calendar },
            { to: "/professor/financeiro", label: "Financeiro", icon: Icon.money },
          ]}
        />
      </RequireRole>
    ),
    children: [
      { index: true, element: <Navigate to="/professor/alunos" replace /> },
      { path: "alunos", element: <TeacherStudents /> },
      { path: "alunos/:id", element: <TeacherStudent /> },
      { path: "disponibilidade", element: <TeacherAvailability /> },
      { path: "financeiro", element: <TeacherFinance /> },
    ],
  },
  {
    path: "/admin",
    element: (
      <RequireRole need="admin">
        <PanelLayout
          area="Admin"
          items={[
            { to: "/admin", label: "Dashboard", icon: Icon.dashboard, end: true },
            { to: "/admin/alunos", label: "Alunos", icon: Icon.students },
            { to: "/admin/equipe", label: "Equipe", icon: Icon.team },
            { to: "/admin/logs", label: "Logs", icon: Icon.logs },
            { to: "/admin/repasses", label: "Repasses", icon: Icon.money },
            { to: "/admin/notas", label: "Notas", icon: Icon.receipt },
            { to: "/admin/configuracoes", label: "Configurações", icon: Icon.settings },
          ]}
        />
      </RequireRole>
    ),
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "alunos", element: <AdminStudents /> },
      { path: "alunos/:id", element: <AdminStudent /> },
      { path: "equipe", element: <AdminTeam /> },
      { path: "logs", element: <AdminLogs /> },
      { path: "repasses", element: <AdminPayouts /> },
      { path: "notas", element: <AdminFiscal /> },
      { path: "configuracoes", element: <AdminSettings /> },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
